import { NavigateNext } from '@mui/icons-material'
import { Button } from '@mui/material'
import { ButtonIcon } from 'app/views/common-components/ButtonIcon'
import { parseFormLabelText } from 'app/views/forms/common/Common'
import { useHistory } from 'react-router'

export const FormRedirectButton = ({
  title,
  typeProps: { url, color, openInNewTab = true },
  ...props
}) => {
  const history = useHistory()
  const parsedUrl = parseFormLabelText({ text: url, returnString: true, ...props })

  return (
    <Button
      link
      url={parsedUrl}
      variant='contained'
      color='primary'
      onClick={e => {
        e.preventDefault()
        if (openInNewTab) {
          window.open(parsedUrl, '_blank')
        } else {
          if (parsedUrl.startsWith('http')) {
            window.location.href = parsedUrl
          } else {
            history.push(parsedUrl)
          }
        }
      }}
    >
      {title}
      <ButtonIcon IconClass={NavigateNext} />
    </Button>

  )
}
